/** Position of the cervix relative to the vaginal axis */
export enum CervicalPosition {
  POSTERIOR = 'posterior',
  MID_POSITION = 'mid-position',
  ANTERIOR = 'anterior',
}

/** Texture/firmness of the cervix */
export enum CervicalConsistency {
  FIRM = 'firm',
  MEDIUM = 'medium',
  SOFT = 'soft',
}

/** Status of the amniotic membranes */
export enum MembraneStatus {
  /** Membranes are intact */
  INTACT = 'intact',
  /** Spontaneous rupture of membranes */
  SROM = 'srom',
  /** Artificial rupture of membranes */
  AROM = 'arom',
}

export interface CervicalExam {
  /** Cervical dilation in cm — 0 to 10 (10 = complete) */
  dilation: number
  /** Cervical effacement as a percentage — 0 to 100 */
  effacement: number
  /** Fetal station relative to ischial spines — −5 to +5 */
  station: number
  /** Position of the cervix */
  position: CervicalPosition
  /** Consistency/firmness of the cervix */
  consistency: CervicalConsistency
  /** Status of the amniotic membranes */
  membranes: MembraneStatus
  /** Presenting part of the fetus (e.g. "Vertex", "Breech", "Face") */
  presentingPart: string
}
